import React from 'react';
import {
  Selectors,
  TierInfo,
  UserTierTypes,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import envData from 'env.json';
import {useNavigation} from '@react-navigation/native';
import ProfileSummary from 'components/ProfileSummary';

const {API_URL, USE_STORYBOOK} = envData;

const ConnectedProfileSummary = () => {
  const {navigate, dispatch} = useNavigation();
  const currentLevel = useWidgetState(
    Selectors.userExtendedTierCodeSelector
  ) as UserTierTypes;
  const currentTierInfo = useWidgetState(
    Selectors.userCurrentTierInfoSelector
  ) as TierInfo;
  const fullName = useWidgetState(Selectors.userFullNameSelector) as string;
  const nextTierInfo = useWidgetState(
    Selectors.userNextTierInfoSelector
  ) as TierInfo;
  const rewardCredits = useWidgetState(
    Selectors.userRewardCreditSelector
  ) as number;
  const tierCredits = useWidgetState(
    Selectors.userTierCreditSelector
  ) as number;
  const asOfDate = useWidgetState(
    Selectors.rewardCreditAsOfDateSelector
  ) as string;
  const expirationDate = useWidgetState(
    Selectors.rewardCreditExpirationDateSelector
  ) as string;
  const lastEarnedDate = useWidgetState(
    Selectors.rewardCreditLastEarnedDateSelector
  ) as string;

  return (
    <ProfileSummary
      currentLevel={currentLevel}
      currentTierInfo={currentTierInfo}
      fullName={fullName}
      nextTierInfo={nextTierInfo}
      rewardCredits={rewardCredits}
      tierCredits={tierCredits}
      tierInfo={currentTierInfo}
      asOfDate={asOfDate}
      expirationDate={expirationDate}
      lastEarnedDate={lastEarnedDate}
    />
  );
};

export default ConnectedProfileSummary;
